import isPlainObject from 'lodash-es/isPlainObject';
const defaultGroupSeperator = '&';
const defaultPairSeperator = '=';
export default class KVJoiner {
  constructor({
    groupSeperator = defaultGroupSeperator,
    pairSeperator = defaultPairSeperator,
    shouldSkipEmpty = true,
    shouldEncode = true
  } = {}) {
    this.groupSeperator = groupSeperator;
    this.pairSeperator = pairSeperator;
    this.shouldSkipEmpty = shouldSkipEmpty;
    this.shouldEncode = shouldEncode;
    this.buffer = new Map();
  }

  join() {
    const content = [...this.buffer].filter(([, v]) => !(this.shouldSkipEmpty && (v === '' || v === undefined || v === null))).map(([k, v]) => this.joinPair(k, v)).join(this.groupSeperator);
    this.clear();
    return content;
  }

  add(keys, val) {
    if (isPlainObject(keys)) {
      Object.keys(keys).forEach(key => this.buffer.set(key, keys[key]));
    } else {
      this.buffer.set(keys, val);
    }

    return this;
  }

  clear() {
    this.buffer.clear();
    return this;
  }

  joinPair(k, v) {
    return `${k}${this.pairSeperator}${this.shouldEncode ? encodeURIComponent(v) : v}`;
  }

}